import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { BloodworkAnalysis, PanelMarker, FurtherConsiderations, Section } from '../../models';
import { AnemiaStatus } from './bloodwork-anemia-status';
import { Footer } from '../../Footer';
import { TabsComponent } from '../tabs-component';
import { WBCEvaluation } from './bloodwork-wbc-evaluation';
import { BloodworkEntryStore } from '../../stores/bloodwork-entry-store';

type Props = {
  section: Section;
  panelTitle: string;
  bloodworkAnalysis: BloodworkAnalysis;
  panelMarkers: PanelMarker[];
  furtherConsiderations: FurtherConsiderations;
  evalSmall: number;
  refSmall: number;
  evalLarge: number;
  refLarge: number;
  infoLink: string;
  bloodworkEntryStore: BloodworkEntryStore;
};

export class BloodworkTestAnalysisSection extends React.Component<Props, {}> {
  evaluation = () => {
    const { bloodworkAnalysis, section, evalSmall, evalLarge } = this.props;
    if (section === Section.RBC) {
      return (
        <Col xs={evalSmall} lg={evalLarge}>
          <AnemiaStatus bloodworkAnalysis={bloodworkAnalysis} />
        </Col>  
      );
    } else if (section === Section.WBC && bloodworkAnalysis.wbc.hasValue()) {
      return (
        <Col xs={evalSmall} lg={evalLarge}>
          <WBCEvaluation bloodworkAnalysis={bloodworkAnalysis} />
        </Col>  
      );
    } else {
      return null;
    }
  }

  analysis = () => {
    const { section, bloodworkAnalysis, panelMarkers, furtherConsiderations,
      refSmall, refLarge, bloodworkEntryStore, infoLink } = this.props;
      return (
        <Col xs={refSmall} lg={refLarge}>
          <TabsComponent
            section={section}
            panelMarkers={panelMarkers}
            bloodworkAnalysis={bloodworkAnalysis} 
            furtherConsiderations={furtherConsiderations}
            bloodworkEntryStore={bloodworkEntryStore}
            infoLink={infoLink}
          />
        </Col>
      );
  }

  render() {
    const { panelTitle, panelMarkers } = this.props;
    return (
      <>
      { panelMarkers.length > 0 ?
        <Card>
          <Card.Header>{panelTitle} *</Card.Header>
          <Card.Body>
            <Row>
              {this.evaluation()}
              {this.analysis()}
            </Row>
          </Card.Body>
          <Card.Footer>
            <Footer />
          </Card.Footer>
        </Card>
        : null 
      }
      </>
    );
  }
}
